import { BCMSDefaultModel, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import TransfersPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/TransfersPage";
import Classes, { TransferTemplate, User } from "model";
import { useEffect, useState } from "react";

/**
 * @name CaptureMakeATransferMainDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureMakeATransferMainDDOpen(props) {
    const context = useBCMSContext();
    const model = useModel();
    BCMSRecord.globalControllerFor(Classes, context);
    const [ updateComp, setUpdateComp ] = useState(false);

    const defaultData = getDefaultPageData();
    const defaultUI = getDefaultPageUI(defaultData.transfer, context);
    const addedTemplate = TransferTemplate.init({ id: TransferTemplate.nextID(), name: "Sample", fromAccount: "6", toAccount: "5", defaultAmount: "100" });
    const templates = [ ...TransferTemplate.initAll(), addedTemplate ]

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "transferTemplates" ], templates)
    .submit();

    const ui = BCMSStateManagerCRUD.init(defaultUI)
    .update([ "template", "isActive" ], true)
    .submit();
    
    // We need to update "User" globally since pages like "TransferPage"
    // only modify the page, not shared content like the header.
    useEffect(() => {
        let user = model.user;
        const defaultUserAccount = BCMSDefaultModel.userAccount();
        
        user = { 
            ...user, 
            first: defaultUserAccount.first, 
            last: defaultUserAccount.last, 
            initials: defaultUserAccount.initials,
            allowTransferOnlyTemplates: "true"
        };

        BCMSRecord.batch([
            User.update(user)
        ], context, Classes);

        setUpdateComp(true);
    });
    
    return <TransfersPage data={ data } ui={ ui } />;
}